import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './pages/Home';
import Support from './pages/Support';
import Privacy from './pages/Privacy';

const App: React.FC = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navigation />
      <main className="pt-14">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/support" element={<Support />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

export default App;
